const barcodeFormat = {
  normalizeInput(input) {
    const CHAR_MAPPING = {
      ö: "0",
      Ö: "0",
      "=": "/",
      "+": "*",
    };

    if (!input) return "";
    return input.toLowerCase().replace(/./g, (ch) => CHAR_MAPPING[ch] ?? ch);
  },
  /**
   * If the code is numeric and shorter than 13 digits,
   * also try its EAN-13 representation (left-padded with zeros).
   */
  normalizeForEAN(code) {
    if (!code) return [];
    const s = String(code);

    if (/^\d+$/.test(s) && s.length < 13) {
      return [
        s,
        s.padStart(13, "0"), // EAN-13
      ];
    }

    return [s];
  },

  /**
   * UPC is usually 12 digits.
   * If a 13-digit numeric code starts with 0, also try the 12-digit UPC.
   */
  normalizeForUPC(code) {
    if (!code) return [];
    const s = String(code);

    if (/^\d+$/.test(s) && s.length === 13 && s.startsWith("0")) {
      return [
        s,
        s.substring(1), // UPC-A
      ];
    }

    return [s];
  },

  /**
   * Master normalizer.
   * Returns all meaningful variants for a barcode.
   */
  normalize(code) {
    if (!code) return [];
    code = this.normalizeInput(code);
    const variants = new Set([
      ...this.normalizeForEAN(code),
      ...this.normalizeForUPC(code),
    ]);

    return Array.from(variants);
  },
};

export default barcodeFormat;
